import { render, staticRenderFns } from "./pInviteIndex.vue?vue&type=template&id=23e5abe5&"
import script from "./pInviteIndex.vue?vue&type=script&lang=js&"
export * from "./pInviteIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports